<template>
    <div class="room__sidebar">
        <div class="room__chat chat">
            <user-info></user-info>
            <messages></messages>
            <message-form></message-form>
        </div>
    </div>
</template>

<script>
    import MessageForm from './MessageForm.vue';
    import Messages from './Messages.vue';
    import UserInfo from "../UserInfo";

    export default {
		name: 'Chat',
        components: {
			MessageForm,
            Messages,
            UserInfo
        },

    }
</script>
